<header class="sidebar-header">
  <mat-toolbar>
    <h2 tabindex="-1" cdkFocusInitial>How can we help you?</h2>
    <button class="close-button" type="button" matIconButton (click)="onClick_toggleHelp()" aria-label="close help" matTooltip="Close help">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>
</header>

<form class="help-sidebar__form" role="form" (submit)="onSubmit_searchArticles($event)" (reset)="onReset_clearSearch()" aria-labelledby="aria_help_sidebar_search">
  <mat-form-field>
    <mat-label id="aria_help_sidebar_search">Search help articles</mat-label>
    <input matInput name="search" [(ngModel)]="searchString" (input)="onSearchInput(searchString)">
    <mat-icon matPrefix>search</mat-icon>
    @if (searchString) {
      <button matIconButton matSuffix type="reset" matTooltip="Clear Search">
        <mat-icon matSuffix>close</mat-icon>
      </button>
    }
  </mat-form-field>
</form>

<div class="help-sidebar__wrapper">
  @if (relevantArticles?.length > 0) {
    <section class="help-sidebar__section" aria-labelledby="aria_relevant_articles">
      <h3 id="aria_relevant_articles">Relevant Articles</h3>
      @for (section of relevantGroups; track section.group) {
        @if (section.group) {
          <h4 class="group-subheader">{{section.group}}</h4>
        }
        <ul class="help-sidebar__articles">
          @for (article of section.articles; track article) {
            <li class="help-sidebar__article">
              @if (!section.group) {
                <h4>{{article.title}}</h4>
              }
              @if (section.group) {
                <h5>{{article.title}}</h5>
              }
              <div class="gcr-help" [innerHtml]="article.trustedBody"></div>
            </li>
          }
        </ul>
      }
    </section>
  }

  <section class="help-sidebar__section" aria-labelledby="aria_other_articles">
    <h3 id="aria_other_articles">@if (relevantArticles?.length > 0) {
      Other
    }Articles</h3>
    <ul class="help-sidebar__articles">
      @for (article of otherArticles; track article) {
        <li class="help-sidebar__article">
          <h4>{{article.title}}</h4>
          <div class="gcr-help" [innerHtml]="article.trustedBody"></div>
        </li>
      }
    </ul>
  </section>
</div>

@if (showViewAllLink && totalArticleCount > relevantArticles?.length + otherArticles?.length && appService.currentUrl !== 'help') {
  <mat-divider></mat-divider>
  <a [routerLink]="viewAllRoute" class="view-all" matButton="tonal">View All Articles</a>
}
